const ApplicationName = 'Ops Hub';

export {
    ApplicationName,
};
